"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_apollo_1 = require("react-apollo");
var react_hook_form_1 = require("react-hook-form");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var modal_1 = require("../../components/common/modal");
var form_element_hook_1 = require("../../components/form/form-element-hook");
var frontend_toolkit_1 = require("frontend-toolkit");
var sport_select_1 = require("../../components/form/sport-select");
var CreateSeason = require("../../core/gql/mutations/create-season");
var UpdateSeason = require("../../core/gql/mutations/update-season");
var QuerySeasons = require("../../core/gql/queries/seasons");
var ShowSeason = require("../../core/gql/queries/show-season");
var ShowOrganization = require("../../core/gql/queries/show-organizations");
var SetFeedbackMessage = require("../../core/gql/mutations/set-feedback-message");
var apollo_helpers_1 = require("../../core/apollo-helpers");
var CreateElement = form_element_hook_1.default;
require("./season-edit.scss");
var divisionAttributeDescription = function (selectedAttributes) {
    if (!selectedAttributes || selectedAttributes.length < 1) {
        return null;
    }
    if (selectedAttributes.length == 1) {
        return selectedAttributes[0].name;
    }
    else if (selectedAttributes.length == 2) {
        return selectedAttributes.map(function (attr) { return attr.name; }).join(", ");
    }
    else {
        return selectedAttributes[0].name + "..." + selectedAttributes[selectedAttributes.length - 1].name;
    }
};
var SeasonEdit = function (_a) {
    var _b, _c, _d, _e;
    var program = _a.program, activitySeasonType = _a.activitySeasonType, selectedSeasonId = _a.selectedSeasonId, isOpen = _a.isOpen, onClose = _a.onClose;
    var mutationOptions = {
        refetchQueries: [{ query: QuerySeasons.QUERY, variables: { programId: program.id } }],
    };
    var _f = react_apollo_1.useMutation(UpdateSeason.MUTATION, mutationOptions), updateSeason = _f[0], updateSeasonResponse = _f[1];
    var _g = react_apollo_1.useMutation(CreateSeason.MUTATION, mutationOptions), createSeason = _g[0], createSeasonResponse = _g[1];
    var setFeedbackMessage = react_apollo_1.useMutation(SetFeedbackMessage.MUTATION)[0];
    var loadPreviousSeasonsResponse = react_apollo_1.useQuery(QuerySeasons.QUERY, {
        variables: { programId: program.id },
    });
    var seasonForm = react_hook_form_1.useForm();
    var setupFormDefaults = React.useCallback(function (data) {
        var _a;
        Object.entries({
            name: (_a = data === null || data === void 0 ? void 0 : data.showSeason) === null || _a === void 0 ? void 0 : _a.name,
            startDate: (data === null || data === void 0 ? void 0 : data.showSeason.startDate) ? frontend_toolkit_1.DateService.stringToDate(data === null || data === void 0 ? void 0 : data.showSeason.startDate, frontend_toolkit_1.DateFormat.YYYY_MM_DD) : "",
            endDate: (data === null || data === void 0 ? void 0 : data.showSeason.endDate) ? frontend_toolkit_1.DateService.stringToDate(data === null || data === void 0 ? void 0 : data.showSeason.endDate, frontend_toolkit_1.DateFormat.YYYY_MM_DD) : "",
            copyDivisionStructure: true,
        }).forEach(function (_a) {
            var k = _a[0], v = _a[1];
            seasonForm.setValue(k, v);
        });
    }, []);
    var showSeasonResponse = react_apollo_1.useQuery(ShowSeason.QUERY, {
        variables: { seasonId: selectedSeasonId },
        skip: selectedSeasonId == null,
        onCompleted: setupFormDefaults,
    });
    var showOrgResponse = react_apollo_1.useQuery(ShowOrganization.QUERY, {
        variables: { organizationId: program.organizationId },
    });
    form_element_hook_1.useFormDefaults(showSeasonResponse.data, setupFormDefaults, [showSeasonResponse.called, showSeasonResponse.loading]);
    var register = seasonForm.register, handleSubmit = seasonForm.handleSubmit, watch = seasonForm.watch, setValue = seasonForm.setValue, getValues = seasonForm.getValues;
    var copyDivisionStructureSelected = watch("copyDivisionStructure");
    // If copy division structure is deselected...
    if (!copyDivisionStructureSelected && getValues()["copyTeamStructure"] == true) {
        // then deselect copyTeamStructure
        setValue("copyTeamStructure", false);
    }
    var isEditing = !!selectedSeasonId;
    var isSubmitting = updateSeasonResponse.loading || createSeasonResponse.loading;
    var _h = React.useState(false), isShowingSelectPreviousSeason = _h[0], setIsShowingSelectPreviousSeason = _h[1];
    var sportId = ((_c = (_b = showSeasonResponse.data) === null || _b === void 0 ? void 0 : _b.showSeason) === null || _c === void 0 ? void 0 : _c.sportId) || program.sportId;
    var areaOfOperation = ((_e = (_d = showSeasonResponse.data) === null || _d === void 0 ? void 0 : _d.showSeason) === null || _e === void 0 ? void 0 : _e.areaOfOperation) || program.areaOfOperation;
    var attributeValues = [
        sport_select_1.getSportName(sportId),
        areaOfOperation === null || areaOfOperation === void 0 ? void 0 : areaOfOperation.name,
    ];
    var genderDescription = divisionAttributeDescription(program.competitionGenders);
    if (genderDescription) {
        attributeValues.push(genderDescription);
    }
    var ageDivsionDescription = divisionAttributeDescription(program.ageDivisions);
    if (ageDivsionDescription) {
        attributeValues.push(ageDivsionDescription);
    }
    var levelDescriptions = divisionAttributeDescription(program.competitionLevels);
    if (levelDescriptions) {
        attributeValues.push(levelDescriptions);
    }
    var readyToShow = (showSeasonResponse.called == false || apollo_helpers_1.isQueryFinished(showSeasonResponse)) &&
        apollo_helpers_1.isQueryFinished(showOrgResponse);
    var submit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var organization, feedbackMessage, submitValues, e_1, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    organization = showOrgResponse.data.showOrganization;
                    feedbackMessage = void 0;
                    submitValues = __assign(__assign({}, values), { programId: program.id, startDate: frontend_toolkit_1.DateService.dateToString(values.startDate, frontend_toolkit_1.DateFormat.YYYY_MM_DD), endDate: frontend_toolkit_1.DateService.dateToString(values.endDate, frontend_toolkit_1.DateFormat.YYYY_MM_DD), country: organization.country, zipCode: organization.zipCode, timezone: organization.timezone, type: activitySeasonType, id: selectedSeasonId, sportId: parseInt(sportId), areaOfOperation: areaOfOperation === null || areaOfOperation === void 0 ? void 0 : areaOfOperation.id, ageDivisions: program.ageDivisions.map(function (tag) { return tag.id; }), competitionGenders: program.competitionGenders.map(function (tag) { return tag.id; }), competitionLevels: program.competitionLevels.map(function (tag) { return tag.id; }) });
                    if (submitValues.fromSeasonId) {
                        submitValues.copyFromSeason = {
                            seasonId: submitValues.fromSeasonId,
                            copyDivisionStructure: submitValues.copyDivisionStructure,
                            copyTeamStructure: submitValues.copyTeamStructure,
                        };
                    }
                    if (!selectedSeasonId) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateSeason({ variables: submitValues })];
                case 1:
                    _a.sent();
                    feedbackMessage = "The season " + submitValues.name + " has been updated.";
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, createSeason({ variables: submitValues })];
                case 3:
                    _a.sent();
                    feedbackMessage = "The season " + submitValues.name + " has been created.";
                    _a.label = 4;
                case 4:
                    hide(true);
                    setFeedbackMessage({
                        variables: {
                            message: feedbackMessage,
                            isError: false,
                            autoclose: true,
                        },
                    });
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _a.sent();
                    errorMessage = !selectedSeasonId
                        ? "Season create failed. Please try again."
                        : "Season update failed. Please try again.";
                    setFeedbackMessage({
                        variables: {
                            message: errorMessage,
                            isError: true,
                            autoclose: true,
                        },
                    });
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var hide = function (_updated) {
        setIsShowingSelectPreviousSeason(false);
        return onClose(false);
    };
    var showSeasonDropdown = function (updated) {
        setIsShowingSelectPreviousSeason(!!updated);
    };
    var configureSeasonSelectData = function (data) {
        return data.seasons
            .filter(function (e) { return e.type == activitySeasonType; })
            .map(function (e) { return ({ text: e.name, value: e.id }); });
    };
    var showPreviousSeasons = !isEditing &&
        apollo_helpers_1.isQueryFinished(loadPreviousSeasonsResponse) &&
        configureSeasonSelectData(loadPreviousSeasonsResponse.data).length > 0;
    return (React.createElement(modal_1.default, { isOpen: isOpen, onClose: function () { return onClose(false); } }, readyToShow && (React.createElement("form", { onSubmit: handleSubmit(submit) },
        React.createElement("div", { className: "page-content u-xs-padTopLg u-xs-padRightLg u-xs-padLeftLg" },
            React.createElement("div", null,
                React.createElement("div", { className: "page-content-header Grid u-flexAlignItemsCenter" },
                    React.createElement("div", { className: "Grid-cell u-xs-size1of2 u-padBottomMd" },
                        React.createElement("h2", null, program.name))),
                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size12of12" }, attributeValues.map(function (attr) { return attr && (React.createElement("span", { className: "attribute-pill", key: attr }, attr)); })),
                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size12of12" },
                    React.createElement(CreateElement, { label: "Season Name", useHookResponse: seasonForm, inputRef: register({
                            required: "You must enter a name for the season.",
                        }), field: "name", type: "text", placeholder: "Season Name (e.g. Fall 2021)" })),
                React.createElement(teamsnap_ui_1.Grid, { isWithGutter: true },
                    React.createElement(teamsnap_ui_1.Cell, { mods: "u-size6of12" },
                        React.createElement(CreateElement, { label: "Start Date", useHookResponse: seasonForm, inputRef: register({
                                required: false,
                            }), field: "startDate", type: "date", placeholder: "TBD" })),
                    React.createElement(teamsnap_ui_1.Cell, { mods: "u-size6of12" },
                        React.createElement(CreateElement, { label: "End Date", useHookResponse: seasonForm, inputRef: register({
                                required: false,
                            }), field: "endDate", type: "date", placeholder: "TBD" }))),
                showPreviousSeasons && (React.createElement(teamsnap_ui_1.Grid, null,
                    React.createElement(teamsnap_ui_1.Cell, { mods: "u-size12of12" },
                        React.createElement("h4", { className: "FieldGroup-label u-padTopMd u-padBottomSm" }, "Season Information:"),
                        React.createElement("div", null,
                            React.createElement(teamsnap_ui_1.Radio, { mods: "u-padBottomSm", name: "copy-dialog-true", label: "Copy information from a prior season", group: "copy-dialog", inputProps: {
                                    onChange: function () { return showSeasonDropdown(true); },
                                    "data-testid": "copy-dialog-true",
                                    checked: isShowingSelectPreviousSeason,
                                } }),
                            React.createElement("small", { className: "u-spaceLeftLg u-block" }, "Copy program and payment settings. Clear rosters, communications, commissioners and payment history")),
                        isShowingSelectPreviousSeason && (React.createElement(React.Fragment, null,
                            React.createElement(CreateElement, { useHookResponse: seasonForm, inputRef: register({
                                    required: false,
                                }), className: "u-spaceLeftLg u-padTopMd", field: "fromSeasonId", type: "select", placeholder: "select a season", options: configureSeasonSelectData(loadPreviousSeasonsResponse.data) }),
                            React.createElement("div", { className: "u-spaceLeftLg u-padTopMd" },
                                React.createElement(CreateElement, { useHookResponse: seasonForm, inputRef: register({
                                        required: false,
                                    }), field: "copyDivisionStructure", type: "checkbox", label: "Copy Division Structure" }),
                                React.createElement(CreateElement, { className: "u-spaceLeftLg u-padTopMd", useHookResponse: seasonForm, inputRef: register({
                                        required: false,
                                    }), field: "copyTeamStructure", disabled: copyDivisionStructureSelected != true, type: "checkbox", label: "Copy Team Structure" })))),
                        React.createElement(teamsnap_ui_1.Radio, { mods: "u-padTopLg u-padBottomSm", name: "copy-dialog-false", label: "Start fresh for the new season", group: "copy-dialog", inputProps: {
                                onChange: function () { return showSeasonDropdown(false); },
                                checked: isShowingSelectPreviousSeason == false,
                            } })))),
                React.createElement(teamsnap_ui_1.Cell, { mods: "u-textLeft u-padTopXl u-padBottomXl u-spaceBottomXl" },
                    React.createElement("div", { className: "button-list" },
                        React.createElement(teamsnap_ui_1.Button, { mods: "Button--negative", icon: "dismiss", onClick: hide }, "Cancel"),
                        React.createElement(teamsnap_ui_1.Button, { type: "submit", isDisabled: isSubmitting, color: "primary", icon: isSubmitting ? null : "check" },
                            isSubmitting && React.createElement(teamsnap_ui_1.Loader, { type: "spin", style: { width: "13px", height: "13px" } }),
                            isEditing ? "Update" : "Create",
                            " Season")))))))));
};
exports.default = SeasonEdit;
//# sourceMappingURL=season-edit.js.map